/**
 * Pet Mindful · Reels de Instagram y TikTok
 *
 * Patron «facade»: la tarjeta muestra la miniatura y solo inserta el iframe
 * cuando alguien le da clic. Cinco reels incrustados de entrada significan
 * cinco iframes de terceros en el LCP, y el home no lo aguanta.
 */
class PMReel extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-pm-reel-play]');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.play(), { once: true });
  }

  play() {
    const src = this.dataset.embed;
    if (!src) return;

    const frame = document.createElement('iframe');
    frame.src = src;
    frame.loading = 'lazy';
    frame.allow = 'autoplay; clipboard-write; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    frame.title = this.dataset.network === 'tiktok' ? 'Reel de TikTok' : 'Reel de Instagram';
    frame.setAttribute('scrolling', 'no');

    this.appendChild(frame);
    this.button.remove();
  }
}

if (!customElements.get('pm-reel')) {
  customElements.define('pm-reel', PMReel);
}
